import {
  Box,
  Flex,
  Spinner,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
} from "@chakra-ui/react";
import TrackingPageLayout from "components/TrackingPageLayout";
import { useGuardSites } from "hooks/useGuard";

export default function TrackingGuardSitesPage() {
  const { sites, isLoading, error } = useGuardSites();

  return (
    <TrackingPageLayout title="Sites surveillés">
      {error && (
        <Text color="red.600" mb={3} px={4} pt={4}>
          Erreur lors du chargement des sites.
        </Text>
      )}
      {isLoading ? (
        <Flex justify="center" py={8}><Spinner /></Flex>
      ) : (sites?.length ?? 0) === 0 ? (
        <Box p={8} textAlign="center"><Text color="gray.600">Aucun site disponible.</Text></Box>
      ) : (
        <Box overflowX="auto" px={4} pb={4}>
          <Table size="sm">
            <Thead>
              <Tr>
                <Th>Nom</Th>
                <Th>Adresse</Th>
                <Th>Rayon (m)</Th>
              </Tr>
            </Thead>
            <Tbody>
              {sites.map((s) => (
                <Tr key={s.id}>
                  <Td>{s.name}</Td>
                  <Td>{s.address ?? "—"}</Td>
                  <Td>{s.radius_meters ?? "—"}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      )}
    </TrackingPageLayout>
  );
}

